export const UpdateTaskSorting = 'sort/task/UPDATE'
